<div
    class="intro position-relative ff-spectral w-100 d-flex flex-column justify-content-center align-items-center text-center">
    <div class="position-relative z-index-3">
        <h1 class="fw-bold text-white text-shadow mb-4 mb-xl-3 header-title">{{ title }}</h1>
        <div class="intro__text fs-6 fs-lg-4 text-white text-shadow mx-auto">
            {{ text }}
        </div>
    </div>
    <div class="intro__overlay bg-primary position-absolute"></div>
    <img
        class="image-as-bg"
        [src]="backgroundImg"
        [appScrset]="backgroundImg"
        [width]="1920" />
</div>
